import { defaultQueryParam } from '@/composables/state/projectSearchApp';
import axios from 'axios';

if (!import.meta.env.VITE_APP_STAFF_INFO_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_STAFF_INFO_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_STAFF_INFO_URL;
const staffLimit = 900; // magnolia delivery api doesnt allow infinite -1 limit, so going with a number of staff were unlikely to hit for a while

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

async function getAllStaffProjects () {
  const abmiWebApiUrl = import.meta.env.VITE_APP_HOME_URL;

  const apiFct = '/.rest/website/';
  try {
    const params:Record<string, any> = { offset: 0, limit: 100000 };
    params['@ancestor'] = defaultQueryParam.rootPath;
    const response = await axios.get(abmiWebApiUrl + apiFct, { params });
    const data = response.data.results ?? [];

    params['@ancestor'] = '/abmi-home/data-resources';
    const responseData = await axios.get(abmiWebApiUrl + apiFct, { params });
    return [...data, ...(responseData.data.results ?? [])];
  } catch (error) {
    console.error(error);
    return [];
  }
}
async function getAllStaffs (path: any) {
  const apiFct = `?@ancestor=${path}&limit=${staffLimit}`;
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data;

    /* get project uuid and title, path */
    const projects = await getAllStaffProjects();
    const projectIdTitleLookups:Record<string, any> = {};
    projects?.forEach((row: Record<string, any>) => {
      projectIdTitleLookups[row['@id']] = { title: row.title, path: row['@path'] };
    });
    const sortedData = sortData(data.results);
    (sortedData ?? []).forEach((row: Record<string, any>) => {
      if (row.projects.length > 0) {
        row.projectTitles = [];
        row.projects.forEach((uuid:string) => {
          if (projectIdTitleLookups[uuid]) {
            row.projectTitles.push(projectIdTitleLookups[uuid]);
          }
        });
      }
      if (row.image != null) {
        row.imagePath = row.image.renditions['max-200']?.link;
      }
    });

    return sortedData;
  } catch (error) {
    return (error);
  }
}
/** Joan: not very sure the sort and group purpose. */

function sortData (data: any) {
  const grouped = groupByCentre(data, 'center');
  // then sort within each centre alphabetically
  const sortedGroups = alphabetizeCentres(grouped);
  // then return it to a format the table can use
  const finalArray: any[] = [];
  const sortedNames = Object.keys(sortedGroups);
  sortedNames.sort();
  // special case: put executive director as first
  const director = sortedGroups['Executive Office'].filter(staff => {
    if (staff.jobTitle.toLowerCase() === 'executive director') {
      return staff;
    }
    return null;
  });
  finalArray.push(director[0]);
  sortedNames.forEach(centre => {
    sortedGroups[centre].forEach((item: any) => {
      if (item.name !== director[0].name) { // name (email) is primary key
        finalArray.push(item);
      }
    });
  });

  return finalArray;
}

function groupByCentre (data: any[], centre: string) {
  // returns an object with each centre as an array
  return data.reduce((prevVal: { [x: string]: any[]; }, currentVal: { [x: string]: string | number; }) => {
    const key = currentVal[centre];
    if (!prevVal[key]) {
      prevVal[currentVal[centre]] = [];
    }
    prevVal[currentVal[centre]].push(currentVal);
    return prevVal;
  }, {});
}

function alphabetizeCentres (groups: { [x: string]: any[]; }) {
  for (const centre in groups) {
    groups[centre].sort((a: { name: number; }, b: { name: number; }) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }
  return groups;
}

const abmiStaffApi = {
  getAllStaffs
};

export default abmiStaffApi;
